
import { ExampleModalType } from '../types';

interface CapExampleModalProps {
  open: boolean;
  activeType: ExampleModalType;
  onClose: () => void;
  onChangeType: (type: ExampleModalType) => void;
}

const examples: { type: ExampleModalType; title: string; desc: string; image: string }[] = [
  {
    type: '三流差异留痕',
    title: '三流差异留痕',
    desc: '平台流水、收款、报关、发票四流自动对齐，差异项标红留痕，异常可追溯',
    image: 'https://public.readdy.ai/ai/img_res/588c375868f630a4abfb4c0e298ef5d3.jpg',
  },
  {
    type: '校验报告',
    title: '校验报告',
    desc: '字段缺失、金额异常、要素逻辑提前提示，提交前拦截问题，减少退回返工',
    image: 'https://readdy.ai/api/search-image?query=Pre-submission%20validation%20report%20interface%20showing%20field%20validation%20results%20with%20warning%20icons%20for%20missing%20fields%20amount%20anomalies%20and%20logic%20errors%20professional%20compliance%20checking%20software%20clean%20organized%20layout%20with%20green%20checkmarks%20and%20red%20warning%20indicators%20for%20each%20validation%20rule&width=700&height=420&seq=cap-example-validation-v1&orientation=landscape',
  },
  {
    type: '归档包目录',
    title: '归档包目录',
    desc: '按批次 / 票号归档，关键材料一键定位，核销 / 抽查随时可查可下载',
    image: 'https://readdy.ai/api/search-image?query=Organized%20archive%20directory%20interface%20with%20hierarchical%20folder%20structure%20document%20management%20system%20showing%20categorized%20export%20compliance%20files%20with%20batch%20numbers%20ticket%20numbers%20professional%20file%20organization%20UI%20clean%20layout%20with%20search%20functionality%20download%20buttons%20and%20document%20preview%20thumbnails&width=700&height=420&seq=cap-example-archive-v1&orientation=landscape',
  },
];

export default function CapExampleModal({ open, activeType, onClose, onChangeType }: CapExampleModalProps) {
  if (!open) return null;

  const current = examples.find((e) => e.type === activeType) ?? examples[0];

  return (
    <div
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl w-full max-w-[860px] overflow-hidden relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Tabs */}
        <div className="bg-gray-50 flex border-b border-gray-200">
          {examples.map((ex) => (
            <button
              key={ex.type}
              onClick={() => onChangeType(ex.type)}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeType === ex.type
                  ? 'bg-white text-[#14B8A6] border-b-2 border-[#14B8A6]'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              {ex.title}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-2">{current.title}</h3>
          <p className="text-gray-500 text-sm mb-6">{current.desc}</p>
          <div className="w-full h-[380px] bg-gray-50 rounded-2xl overflow-hidden shadow-inner">
            <img
              src={current.image}
              alt={current.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg text-gray-600"></i>
        </button>
      </div>
    </div>
  );
}
